(function () {
  'use strict';

  if (!window.__lazySectionConfig) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var SKIP_COUNT = window.__lazySectionConfig && window.__lazySectionConfig.skip;
  if (SKIP_COUNT == null) SKIP_COUNT = 1;

  var ROOT_MARGIN = (window.__lazySectionConfig && window.__lazySectionConfig.rootMargin) || '500px 0px';
  var MIN_HEIGHT = (window.__lazySectionConfig && window.__lazySectionConfig.minHeight) || 120;
  var IDLE_TIMEOUT = (window.__lazySectionConfig && window.__lazySectionConfig.idleTimeout) || 2500;
  var INIT_DELAY = (window.__lazySectionConfig && window.__lazySectionConfig.initDelay) || 250;

  function getSectionApiId(el) {
    if (!el.id || el.id.indexOf('shopify-section-') !== 0) return null;
    return el.id.slice('shopify-section-'.length);
  }

  function triggerContentUpdate() {
    if (window.BoosterTheme && window.BoosterTheme.events) {
      window.BoosterTheme.events.trigger('booster:content:update', { trigger: 'lazy-section' });
    }
  }

  function markSectionLoaded(el) {
    delete el.dataset.lazyPending;
    delete el.dataset.lazyLoading;
    el.dataset.lazyLoaded = '';
    el.style.minHeight = '';
    el.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    triggerContentUpdate();
  }

  function applyPlaceholder(el, sectionId, height) {
    el.dataset.lazySection = sectionId;
    el.dataset.lazyPending = '';
    el.style.minHeight = height + 'px';
    // Do not clear innerHTML — wiping forms breaks add-to-cart / Corner Cart
  }

  function loadSection(el) {
    if (!el.dataset.lazySection || el.dataset.lazyLoading || el.dataset.lazyLoaded !== undefined) return;
    el.dataset.lazyLoading = '';
    // Reveal existing markup instead of re-fetching (re-fetch destroyed ATC handlers)
    markSectionLoaded(el);
  }

  function prepareAndObserve(lazySections) {
    var heights = [];
    var i;

    for (i = 0; i < lazySections.length; i++) {
      heights[i] = Math.max(lazySections[i].el.offsetHeight, MIN_HEIGHT);
    }

    for (i = 0; i < lazySections.length; i++) {
      applyPlaceholder(lazySections[i].el, lazySections[i].sectionId, heights[i]);
    }

    if (!('IntersectionObserver' in window)) {
      lazySections.forEach(function (item) {
        loadSection(item.el);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadSection(entry.target);
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0 }
    );

    lazySections.forEach(function (item) {
      observer.observe(item.el);
    });
  }

  function schedulePrepare(lazySections) {
    function run() {
      prepareAndObserve(lazySections);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: IDLE_TIMEOUT });
    } else {
      setTimeout(run, INIT_DELAY);
    }
  }

  function collectLazySections() {
    var main = document.querySelector('main[role="main"]');
    if (!main) return [];

    var sections = main.querySelectorAll(':scope > .shopify-section');
    var lazySections = [];
    var i;

    for (i = 0; i < sections.length; i++) {
      var el = sections[i];
      if (el.dataset.lazyExclude !== undefined) continue;
      if (i < SKIP_COUNT) continue;

      var sectionId = getSectionApiId(el);
      if (!sectionId) continue;

      lazySections.push({ el: el, sectionId: sectionId });
    }

    return lazySections;
  }

  function start() {
    var lazySections = collectLazySections();
    if (!lazySections.length) return;
    schedulePrepare(lazySections);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
